import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import r from "../core/Error.js";
import { JSONSupport as e } from "../core/JSONSupport.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as s } from "../core/accessorSupport/decorators/subclass.js";
import l from "./PortalFolder.js";
import n from "./PortalGroup.js";

var _i;

var u = _i = /*#__PURE__*/function (_e) {
  _inherits(i, _e);

  var _super = _createSuper(i);

  function i() {
    var _this;

    _classCallCheck(this, i);

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(t)), _this.access = null, _this.created = null, _this.culture = null, _this.description = null, _this.email = null, _this.fullName = null, _this.modified = null, _this.orgId = null, _this.portal = null, _this.preferredView = null, _this.privileges = null, _this.region = null, _this.role = null, _this.roleId = null, _this.sourceJSON = null, _this.units = null, _this.username = null, _this.userType = null;
    return _this;
  }

  _createClass(i, [{
    key: "thumbnailUrl",
    get: function get() {
      var t = this.url,
          r = this.thumbnail;
      return t && r ? this.portal._normalizeUrl("".concat(t, "/info/").concat(r, "?f=json")) : null;
    }
  }, {
    key: "userContentUrl",
    get: function get() {
      var t = this.get("portal.restUrl");
      return t ? "".concat(t, "/content/users/").concat(this.username) : null;
    }
  }, {
    key: "url",
    get: function get() {
      var t = this.get("portal.restUrl");
      return t ? "".concat(t, "/community/users/").concat(this.username) : null;
    }
  }, {
    key: "addItem",
    value: function addItem(t) {
      var _this2 = this;

      var r = t && t.item,
          e = t && t.data,
          o = t && t.folder,
          s = {
        method: "post"
      };
      r && (s.query = r.createPostQuery(), null != e && ("string" == typeof e ? s.query.text = e : "object" == typeof e && (s.query.text = JSON.stringify(e))));
      var l = this.userContentUrl;
      return o && (l += "/" + ("string" == typeof o ? o : o.id)), this.portal._request(l + "/addItem", s).then(function (t) {
        return r.id = t.id, r.portal = _this2.portal, r.loaded ? r.reload() : r.load();
      });
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(t) {
      var r = this.userContentUrl;
      return t.ownerFolder && (r += "/" + t.ownerFolder), this.portal._request(r + "/items/".concat(t.id, "/delete"), {
        method: "post"
      }).then(function () {
        t.id = null, t.portal = null;
      });
    }
  }, {
    key: "deleteItems",
    value: function deleteItems(t) {
      var r = this.userContentUrl + "/deleteItems",
          e = t.map(function (t) {
        return t.id;
      });

      if (e.length) {
        var _o = {
          method: "post",
          query: {
            items: e.join(",")
          }
        };
        return this.portal._request(r, _o).then(function () {
          t.forEach(function (t) {
            t.id = null, t.portal = null;
          });
        });
      }

      return Promise.resolve(void 0);
    }
  }, {
    key: "fetchFolders",
    value: function fetchFolders() {
      var _this3 = this;

      var t = {
        query: {
          num: 1
        }
      };
      return this.portal._request(this.userContentUrl, t).then(function (t) {
        var r;
        return r = t && t.folders ? t.folders.map(function (t) {
          var r = l.fromJSON(t);
          return r.portal = _this3.portal, r;
        }) : [], r;
      });
    }
  }, {
    key: "fetchGroups",
    value: function fetchGroups() {
      var _this4 = this;

      return this.portal._request(this.url).then(function (t) {
        var r;
        return r = t && t.groups ? t.groups.map(function (t) {
          var r = n.fromJSON(t);
          return r.portal = _this4.portal, r;
        }) : [], r;
      });
    }
  }, {
    key: "fetchItems",
    value: function fetchItems(t) {
      var _this5 = this;

      t || (t = {});
      var r,
          e = this.userContentUrl;
      return t.folder && (e += "/" + t.folder.id), import("./PortalItem.js").then(function (_ref) {
        var o = _ref.default;
        r = o;
        var s = {
          folders: !1,
          num: t.num || 10,
          start: t.start || 1,
          sortField: t.sortField || "created",
          sortOrder: t.sortOrder || "asc"
        };
        return _this5.portal._request(e, {
          query: s
        });
      }).then(function (t) {
        var e;
        return t && t.items ? (e = t.items.map(function (t) {
          var e = r.fromJSON(t);
          return e.portal = _this5.portal, e;
        }), Promise.all(e.map(function (t) {
          return t.load();
        })).catch(function (t) {
          return t;
        }).then(function () {
          return {
            items: e,
            nextStart: t.nextStart,
            total: t.total
          };
        })) : {
          items: [],
          nextStart: -1,
          total: 0
        };
      });
    }
  }, {
    key: "fetchTags",
    value: function fetchTags() {
      return this.portal._request(this.url + "/tags").then(function (t) {
        return t.tags;
      });
    }
  }, {
    key: "getThumbnailUrl",
    value: function getThumbnailUrl(t) {
      var r = this.thumbnailUrl;
      return r && t && (r += "&w=".concat(t)), r;
    }
  }, {
    key: "queryFavorites",
    value: function queryFavorites(t) {
      return this.favGroupId ? (this._favGroup || (this._favGroup = new n({
        id: this.favGroupId,
        portal: this.portal
      })), this._favGroup.queryItems(t)) : Promise.reject(new r("internal:unknown", "Unknown internal error", {
        internalError: "Unknown favGroupId"
      }));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      throw new r("internal:not-yet-implemented", "PortalGroup.toJSON is not yet implemented");
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(t) {
      if (!t) return null;
      if (t.declaredClass) throw new Error("JSON object is already hydrated");
      var r = new _i();
      return r.sourceJSON = t, r.read(t), r;
    }
  }]);

  return i;
}(e);

t([o()], u.prototype, "access", void 0), t([o({
  type: Date
})], u.prototype, "created", void 0), t([o()], u.prototype, "culture", void 0), t([o()], u.prototype, "description", void 0), t([o()], u.prototype, "email", void 0), t([o()], u.prototype, "favGroupId", void 0), t([o()], u.prototype, "fullName", void 0), t([o({
  type: Date
})], u.prototype, "modified", void 0), t([o()], u.prototype, "orgId", void 0), t([o()], u.prototype, "portal", void 0), t([o()], u.prototype, "preferredView", void 0), t([o()], u.prototype, "privileges", void 0), t([o()], u.prototype, "region", void 0), t([o()], u.prototype, "role", void 0), t([o()], u.prototype, "roleId", void 0), t([o()], u.prototype, "sourceJSON", void 0), t([o()], u.prototype, "thumbnail", void 0), t([o({
  readOnly: !0
})], u.prototype, "thumbnailUrl", null), t([o()], u.prototype, "units", void 0), t([o({
  readOnly: !0
})], u.prototype, "userContentUrl", null), t([o({
  readOnly: !0
})], u.prototype, "url", null), t([o()], u.prototype, "username", void 0), t([o()], u.prototype, "userType", void 0), u = _i = t([s("esri.portal.PortalUser")], u);
var p = u;
export { p as default };